'use client'

import Link from 'next/link'
import React, { useCallback, useEffect, useState } from 'react'
import CatalogCheckbox from '@/components/catalog/CatalogCheckbox'
import { useDispatch, useSelector } from 'react-redux'
import { setProductType, setAnimalAge, setAnimalNeeds, setAnimalType, setFeedingType, setAnimalTypesCategory, setAnimalPackaging, setCheckboxesCategory, setCheckboxesCategoryType } from '../../redux/features/filterSlice'
import { RootState } from '@/redux/store'
import { CatalogCheckboxFilter, TypeOfAnimal, useGetAllCatalogFiltersQuery, useGetInitialCategoriesQuery } from '@/redux/services/catalogApi'
import { setCatalogBreadCrumbs, setCurrentCatalogCategory } from '@/redux/features/catalogSlice'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

interface Props {
    inContainer?: Boolean
    filters?: any,
    filtersList: any,
    vacancySpecialization: number[],
    vacancyRegion: number[],
    setVacancySpecialization: (state: number) => void,
    setVacancyRegion: (state: number) => void
    resetFilters: () => void
}

const VacancySort: React.FC<Props> = ({ inContainer, filters, filtersList, vacancySpecialization, vacancyRegion, setVacancySpecialization, setVacancyRegion, resetFilters }) => {
    const searchParams = useSearchParams()
    const router = useRouter()
    const pathname = usePathname()

    const {
        title: searchValue,
        animalType,
        animalTypesCategory,
        animalAge,
        animalNeeds,
        productType,
        feedingType,
        animalPackaging,
    } = useSelector((state: RootState) => state.filter)


    useEffect(() => {
        const params = `${animalType.length ? `&animal_type=` + animalType.join(',') : ''}`
            + `${animalAge.length ? `&animal_age=` + animalAge.join(',') : ''}`
            + `${productType.length ? `&type=` + productType.join(',') : ''}`
            + `${feedingType.length ? `&feeding_type=` + feedingType.join(',') : ''}`
            + `${searchValue ? `&search=` + searchValue : ''}`
            + `${animalTypesCategory.length ? `&animal_types_category=` + animalTypesCategory.join(',') : ''}`
            + `${animalNeeds.length ? `&animal_needs=` + animalNeeds.join(',') : ''}`
            + `${animalPackaging.length ? `&packaging_type=` + animalPackaging.join(',') : ''}`

        router.push(`${pathname}?${params.slice(1)}`, { scroll: false })

    }, [animalAge, animalType, productType, animalTypesCategory, animalNeeds, animalPackaging, feedingType, searchValue, searchParams])

    const [filterArray, setFilterArray] = useState<CatalogCheckboxFilter[]>(filters)

    useEffect(() => {
        function getData() {
            setFilterArray(filtersList)
        }
        getData()

    }, [filtersList])

    return (
        <div className={`catalog__sort ${inContainer ? "container" : ''}`}>
            <div className="catalog__sort-content">
                {filterArray && filterArray?.map((filter) => (
                    <>
                        {filter.items.length > 0 && <p className="catalog__sort-title">{filter.title}</p>}
                        <ul className="catalog__sort-list">
                            {filter.items?.map((item) => (
                                <>
                                    {(filter.title === 'Специализация' || filter.title === 'Specialization') && <CatalogCheckbox
                                        key={item.id}
                                        item={item}
                                        updater={(id) => setVacancySpecialization(id)}
                                        state={vacancySpecialization} />}
                                    {(filter.title === 'Округ' || filter.title === "District") && <CatalogCheckbox
                                        key={item.id}
                                        item={item}
                                        updater={(id) => setVacancyRegion(id)}
                                        state={vacancyRegion} />}
                                </>
                            ))}
                        </ul>
                    </>
                ))}
            </div>
            <button
                onClick={resetFilters}
                className="catalog__sort-reset-button button-more">
                Сбросить все
            </button>
        </div>
    )
}

export default VacancySort

